import axios, {AxiosResponse} from 'axios';
import config from '../config';
import store from '../store';

export default class LockManager {
    private static readonly URL_BASE: string = config.API_ROOT + '/lock/';
    private static readonly REFRESH_INTERVAL: number = 30000;
    
    // no one has the lock
    private static readonly AVAILABLE: string = 'available';
    // someone else has the lock
    private static readonly BUSY: string = 'busy';
    // i have the lock
    private static readonly LOCKED: string = 'locked';
    
    public lockEntityKey?: string = undefined;
    public status?: string = 'available';
    
    // number from window.setInterval so we can stop the lock refreshing
    public intervalIds: number[] = [];
    
    public constructor(entity: string, id: number) {
        this.lockEntityKey = `${entity}-${id}`;
    }
    
    public async checkStatus(): Promise<string> {
        const response: AxiosResponse<any> = await axios({
            method: 'GET',
            url: `${LockManager.URL_BASE}${this.lockEntityKey}/`,
            headers: {
                'X-Session': store.state.sessionToken,
            },
        });
        console.log('CheckStatus:', response.data.status);
        this.status = response.data.status;
        return response.data.status;
    }
    
    public async releaseLock() {
        console.log('Releasing lock for ', this.lockEntityKey);
        this.intervalIds.forEach((el) => window.clearInterval(el));
        await axios({
            method: 'DELETE',
            url: `${LockManager.URL_BASE}${this.lockEntityKey}/`,
            headers: {
                'X-Session': store.state.sessionToken,
            },
        });
        this.status = LockManager.AVAILABLE;
    }
    
    public async tryAcquireLock() {
        // status is waiting for the result of get lock
        // this prevents isAvailable from being true which prevents multiple requests to getLock
        this.status = '';
        console.log('tryAcquireLock');
        if (!this.isLocked) {
            await this.getLock();
            this.initAutoRefresh();
        }
    }
    
    public initAutoRefresh() {
        this.intervalIds.push(window.setInterval(this.getLock.bind(this), LockManager.REFRESH_INTERVAL));
    }
    
    public async getLock() {
        try {
            await axios({
                method: 'PUT',
                url: `${LockManager.URL_BASE}${this.lockEntityKey}/`,
                params: {
                    updated: new Date().toISOString(),
                },
                headers: {
                    'X-Session': store.state.sessionToken,
                },
            });
    
            console.log('Lock granted for', this.lockEntityKey);
            this.status = LockManager.LOCKED;
        } catch (e) {
            console.log('Failed to get lock for', this.lockEntityKey);
            this.status = LockManager.BUSY;
            throw e;
        }
    }
    
    public get isBusy(): boolean {
        return this.status === LockManager.BUSY;
    }
    
    public get isLocked(): boolean {
        return this.status === LockManager.LOCKED;
    }
    
    public get isAvailable(): boolean {
        return this.status === LockManager.AVAILABLE;
    }
}
